import React, { useEffect, useRef, useState } from 'react';
import { MEET } from './landingCopy';
import { contactMailto, getContactEmail } from './landingConfig';
import { fetchDemoConfig } from './demoRequestApi';
import DemoRequestForm from './DemoRequestForm';

// State A (first render, and whenever intake is not active): an invitation to mail. Without a configured contact
// address the card is omitted entirely - no button, no mailbox, no replacement promise, never an outage notice.
const ContactInvite = ({ email }) => {
  const [status, setStatus] = useState('');
  const canCopy = typeof navigator !== 'undefined' && !!navigator.clipboard?.writeText;

  const copy = () => {
    navigator.clipboard.writeText(email).then(() => setStatus(MEET.invite.copied), () => setStatus(MEET.invite.copyFailed));
  };

  return (
    <div className="zl-card" data-testid="contact-invite">
      <h3>{MEET.invite.title}</h3>
      <p>{MEET.invite.text}</p>
      <a className="zl-btn zl-btn-primary" href={contactMailto(email, { subject: MEET.mailSubject, body: MEET.mailBody })} data-testid="contact-mailto">
        {MEET.invite.mailPrefix} {email}
      </a>
      <div className="zl-addr">
        <span className="zl-small">{MEET.invite.orMail}</span>
        <output>{email}</output>
        {canCopy && <button type="button" className="zl-copy-btn" onClick={copy}>{MEET.invite.copy}</button>}
      </div>
      <p className="zl-status" aria-live="polite">{status}</p>
      <p className="zl-small">{MEET.invite.privacy}</p>
    </div>
  );
};

// The visible state follows only the backend configuration (GET /api/public/demo-requests/config).
const KennismakingSection = () => {
  const [config, setConfig] = useState({ accepting: false, privacyUrl: null });
  const mounted = useRef(true);
  const email = getContactEmail();

  useEffect(() => {
    mounted.current = true;
    fetchDemoConfig().then((result) => {
      if (mounted.current) setConfig(result);
    });
    return () => {
      mounted.current = false;
    };
  }, []);

  const closeIntake = () => setConfig({ accepting: false, privacyUrl: null });

  return (
    <>
      <span id="demo" className="zl-anchor" aria-hidden="true" />
      <section className="zl-meet" id="kennismaking" aria-labelledby="meet-title">
        <div className="zl-wrap">
          <div>
            <p className="zl-eyebrow">{MEET.eyebrow}</p>
            <h2 id="meet-title">{MEET.title}</h2>
            <p className="zl-intro">{MEET.intro}</p>
            <ol>{MEET.steps.map((step) => <li key={step}>{step}</li>)}</ol>
          </div>
          {config.accepting ? (
            <DemoRequestForm privacyUrl={config.privacyUrl} onUnavailable={closeIntake} />
          ) : (
            email && <ContactInvite email={email} />
          )}
        </div>
      </section>
    </>
  );
};

export default KennismakingSection;
